import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@heroui/react';
import { ROUTES } from '@/shared/config';
import { PageLayout } from '@/shared/ui';

/**
 * Экраны на время загрузки чанка (`lazyPage` в `app/router`): те же шапки и
 * скелеты, что страницы показывают, пока ждут `GET /me/subscription`, —
 * загрузка кода и данных идёт одним шиммером.
 */
export function SubscriptionPageSkeleton() {
  const { t } = useTranslation('SubscriptionPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('title')} onBack={() => void navigate(ROUTES.profile)}>
      <SubscriptionSkeleton />
    </PageLayout>
  );
}

export function PaymentDetailsPageSkeleton() {
  const { t } = useTranslation('SubscriptionPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('paymentTitle')} onBack={() => void navigate(ROUTES.subscription)}>
      <PaymentDetailsSkeleton />
    </PageLayout>
  );
}

export function SubscriptionSkeleton() {
  return (
    <div className="flex flex-col gap-5" aria-busy="true" aria-live="polite">
      <Skeleton className="h-[236px] rounded-2xl" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3 w-32 rounded-full" />
        <Skeleton className="h-[204px] rounded-2xl" />
      </div>
    </div>
  );
}

export function PaymentDetailsSkeleton() {
  return <Skeleton className="h-[360px] rounded-2xl" />;
}
